import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Steps to prepare an environment using the `}<Globals name="shortName" mdxType="Globals" />{` in an existing cluster.`}</p>
    </PageDescription>
    <h2>{`Cloud-Native Toolkit: Quick Installation`}</h2>
    <p>{`Walkthrough of the Cloud Native Toolkit installation on RedHat OpenShift.`}</p>
    <div {...{
      "className": "gatsby-resp-iframe-wrapper",
      "style": {
        "paddingBottom": "56.25%",
        "position": "relative",
        "height": "0",
        "overflow": "hidden"
      }
    }}>{` `}<iframe parentName="div" {...{
        "src": "https://www.youtube.com/embed/97s_uredoSw",
        "frameBorder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        "allowFullScreen": true,
        "style": {
          "position": "absolute",
          "top": "0",
          "left": "0",
          "width": "100%",
          "height": "100%"
        }
      }}></iframe>{` `}</div>
    <Tabs mdxType="Tabs">
      <Tab label="Default" open="true" mdxType="Tab">
        <h3>{`Run the installation using the OpenShift CLI`}</h3>
        <Accordion align="start" mdxType="Accordion">
          <AccordionItem title="Linux or MacOS" open mdxType="AccordionItem">
            <pre><code parentName="pre" {...{
                "className": "language-shell",
                "metastring": "script",
                "script": true
              }}>{`curl -sfL get.cloudnativetoolkit.dev | sh -
`}</code></pre>
          </AccordionItem>
          <AccordionItem title="Windows Users" mdxType="AccordionItem">
            <pre><code parentName="pre" {...{
                "className": "language-shell",
                "metastring": "script",
                "script": true
              }}>{`oc create -f https://raw.githubusercontent.com/cloud-native-toolkit/ibm-garage-iteration-zero/master/install/install-ibm-toolkit.yaml
sleep 5
oc wait pod -l job-name=ibm-toolkit --for=condition=Ready -n default
oc logs job/ibm-toolkit -f -n default

`}</code></pre>
          </AccordionItem>
        </Accordion>
      </Tab>
      <Tab label="Customize" open="true" mdxType="Tab">
        <h3>{`A. Download the manifest `}<inlineCode parentName="h3">{`install-toolkit-yaml`}</inlineCode></h3>
        <ol>
          <li parentName="ol">{`Download the latest Toolkit installation manifest yaml file`}
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-shell",
                "metastring": "script",
                "script": true
              }}>{`curl -LO https://raw.githubusercontent.com/cloud-native-toolkit/ibm-garage-iteration-zero/master/install/install-ibm-toolkit.yaml
`}</code></pre>
          </li>
          <li parentName="ol">{`If you want a specific version of the manifest yaml file visit the `}<a parentName="li" {...{
              "href": "https://github.com/cloud-native-toolkit/ibm-garage-iteration-zero/releases"
            }}>{`release page`}</a>{` and download the corresponding manifest file `}<inlineCode parentName="li">{`install-ibm-toolkit.yaml
`}</inlineCode></li>
        </ol>
        <h3>{`B. Customize Installation`}</h3>
        <ol>
          <li parentName="ol">{`Edit the file `}<inlineCode parentName="li">{`install-ibm-toolkit.yaml`}</inlineCode>{` if you want to change any of the defaults, such as changing the tools namespace, adding a components from the catalog directory or removing a default component.`}</li>
        </ol>
        <h3>{`C. Run the installation using the OpenShift CLI`}</h3>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Run the installation job after customizing the installation script`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-shell",
                "metastring": "script",
                "script": true
              }}>{`oc create -f install-ibm-toolkit.yaml
sleep 5
oc wait pod -l job-name=ibm-toolkit --for=condition=Ready -n default
oc logs job/ibm-toolkit -f -n default

`}</code></pre>
          </li>
        </ol>
      </Tab>
    </Tabs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      